import {
  useActiveAuthProvider,
  useLogout,
  useTranslate,
  useWarnAboutChange,
} from "@refinedev/core";
import { Typography } from "antd";
import type { MouseEventHandler } from "react";
import { useCallback } from "react";

const { Text } = Typography;
const ROLE_KEY = "role";
export const useLogoutHandler = () => {
  const translate = useTranslate();
  const { warnWhen, setWarnWhen } = useWarnAboutChange();
  const authProvider = useActiveAuthProvider();
  const { mutate: mutateLogout } = useLogout({
    v3LegacyAuthProviderCompatible: Boolean(authProvider?.isLegacy),
  });
  const handleLogout: MouseEventHandler = useCallback((event) => {
    event.preventDefault();

    if (warnWhen) {
      const confirm = window.confirm(
        translate(
          "warnWhenUnsavedChanges",
          "Are you sure you want to leave? You have unsaved changes."
        )
      );
      if (confirm) {
        setWarnWhen(false);
      }
    }
    try {
      mutateLogout();
    } catch (error) {
      console.error("Failed to logout", error);
    }
  }, []);
  return handleLogout;
};
export const LogoutButton = () => {
  return <Text>ログアウト</Text>;
};
